module.exports = __webpack_public_path__ + "img/visa-logo.9f8c974e.svg";